///////////////////////////////////////////////////////////////
// Controller for selecting/creating a domain for the wizard //
///////////////////////////////////////////////////////////////
selectDomainCtrl.$inject = ['$state', 'graph', 'adminApi']
export default function selectDomainCtrl($state, graph, adminApi) {
  var self = this
  self.allDomains = []
  self.overwriteRelations = true
  graph.getDomains().then(function(res) {
    if (res.status === 'error') {
      self.errorMessage = res.message
    } else if (angular.isArray(res)) {
      self.errorMessage = null
      self.allDomains = res
    }
  })

  var nextStep = function(domainUuid, importUuid) {
    $state.go('import-wizard.step2', { domainUuid: domainUuid, importUuid: importUuid })
  }

  self.createImport = function(domainUuid, name, overwriteRelations) {
    if (!name) {
      name = 'import for ' + (domainUuid || '(consumer domain)')
    }

    self.loading = true
    adminApi.createImport(domainUuid, name, overwriteRelations).then(function(importRecord) {
      if (!importRecord.uuid && importRecord.status === 'error') {
        self.errorMessage = importRecord.message
      } else {
        nextStep(domainUuid, importRecord.uuid)
      }
    })
  }

  self.createDomain = function(name) {
    self.loading = true
    if (name && name.trim().length > 0) {
      console.log(name)
      graph.createDomain(name.trim()).then(function(res) {
        if (res.status === 'error') {
          self.errorMessage = res.message
        } else if (res.name === name) {
          var domainUuid = res.uuid
          self.createImport(domainUuid, self.importName, self.overwriteRelations)
        } else {
          self.errorMessage =
            'Created domain ' + res.name + ' did not match the name entered ' + name + '.'
        }
        self.loading = false
      })
    }
  }
}
